import { Data } from "../../Models/Common/Common";
import { GetToken, Post } from "../../Utils/AxiosHelper/AxiosHelper";
const api = {
  getAboutUsContent: "configurations/getAboutUsContent",
  getContactUsContent: "configurations/getContactUsContent",
  getAllNews: "configurations/getAllNews",
  getPrivacyContent: "configurations/getPrivacyRules",
  getAllCarPrices: "configurations/getAllCarPrices",
  getManufactureYears: "manufactureyears/getManufactureYears",
  getCarTypeManufactureYears: "manufactureyears/getCarTypeManufactureYears",
  getSaleFaqContents: "contents/getSaleFaqContents",
  getPurchaseFaqContents: "contents/getPurchaseFaqContents",
  getAllFaqContents: "contents/getAllFaqContents",
  getWebBanners: "banners/getWebBanners",
  getSuggestionTypes: "suggestions/getSuggestionTypes",
  insertSuggestion: "suggestions/insertSuggestion",
  getWebInfos: "infos/getWebInfos",
};
const ConfigurationServices = {
  GetAboutUsContent: (command: any, then: Data<any>) => {
    Post(api.getAboutUsContent, command, then);
  },
  GetContactUsContent: (command: any, then: Data<any>) => {
    Post(api.getContactUsContent, command, then);
  },
  GetAllNews: (command: any, then: Data<any>) => {
    Post(api.getAllNews, command, then);
  },
  GetPrivacyContent: (command: any, then: Data<any>) => {
    Post(api.getPrivacyContent, command, then);
  },
  GetAllCarPrices: (command: any, then: Data<any>) => {
    Post(api.getAllCarPrices, command, then);
  },
  GetManufactureYears: (command: any, then: Data<any>) => {
    Post(api.getManufactureYears, command, then);
  },
  GetCarTypeManufactureYears: (command: any, then: Data<any>) => {
    Post(api.getCarTypeManufactureYears, command, then);
  },
  GetPurchaseFaqContents: (command: any, then: Data<any>) => {
    Post(api.getPurchaseFaqContents, command, then);
  },
  GetSaleFaqContents: (command: any, then: Data<any>) => {
    Post(api.getSaleFaqContents, command, then);
  },
  GetAllFaqContents: (command: any, then: Data<any>) => {
    Post(api.getAllFaqContents, command, then);
  },
  GetWebBanners: (command: any, then: Data<any>) => {
    Post(api.getWebBanners, command, then);
  },
  GetSuggestionTypes: (command: any, then: Data<any>) => {
    Post(api.getSuggestionTypes, command, then);
  },
  InsertSuggestion: (command: any, then: Data<any>) => {
    Post(api.insertSuggestion, command, then);
  },
  GetWebInfos: (command: any, then: Data<any>) => {
    Post(api.getWebInfos, command, then);
  },
  GetBaseToken: (then: Data<any>) => {
    GetToken(then);
  },
};
export default ConfigurationServices;
